import { useState, useCallback, useEffect } from 'react';

const FEED_HASH_KEY = 'feedhash';

/**
 * Хук для работы с hash ленты в sessionStorage
 * @returns объект с hash и функциями для работы с ним
 */
export const useSessionHash = () => {
    // Получаем hash из sessionStorage или генерируем новый
    const [hash] = useState(() => {
        // Проверяем доступность sessionStorage (защита от SSR)
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            try {
                const savedHash = sessionStorage.getItem(FEED_HASH_KEY);
                if (savedHash) {
                    return savedHash;
                }
            } catch (error) {
                console.warn('Ошибка при чтении sessionStorage:', error);
            }
        }

        // Генерируем новый hash (работает и на сервере, и в браузере)
        return Date.now().toString();
    });

    // Записываем hash в sessionStorage когда оно становится доступно
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            try {
                // Проверяем, есть ли уже сохраненный hash
                const savedHash = sessionStorage.getItem(FEED_HASH_KEY);
                if (!savedHash) {
                    // Сохраняем текущий hash
                    sessionStorage.setItem(FEED_HASH_KEY, hash);
                }
            } catch (error) {
                console.warn('Ошибка при записи в sessionStorage:', error);
            }
        }
    }, [hash]);

    // Функция для очистки hash из sessionStorage
    const clearHash = useCallback(() => {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            try {
                sessionStorage.removeItem(FEED_HASH_KEY);
            } catch (error) {
                console.warn('Ошибка при удалении из sessionStorage:', error);
            }
        }
    }, []);

    // Очищаем hash при обновлении страницы
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
            const handleBeforeUnload = () => {
                try {
                    sessionStorage.removeItem(FEED_HASH_KEY);
                } catch (error) {
                    console.warn('Ошибка при очистке hash перед обновлением страницы:', error);
                }
            };

            window.addEventListener('beforeunload', handleBeforeUnload);

            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, []);

    return {
        hash,
        clearHash,
    };
};
